import { render, staticRenderFns } from "./BrowsePlateformInfo.vue?vue&type=template&id=b3d706f6&scoped=true&"
import script from "./BrowsePlateformInfo.vue?vue&type=script&lang=js&"
export * from "./BrowsePlateformInfo.vue?vue&type=script&lang=js&"
import style0 from "./BrowsePlateformInfo.vue?vue&type=style&index=0&id=b3d706f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d706f6",
  null
  
)

export default component.exports